

<div nz-row>
    <div nz-col nzSpan="24">

        <nz-card class="leaders-header-card">
            <div class="header-wrapper"> 
                <!-- <div style="margin-right: 20px;">
                    <h3 style="margin-bottom: 6px">Leaderboard</h3>  
                      <h3 style="margin-bottom: 6px">Dashboard</h3>
                </div> -->
                <img src="../../../assets/images/leaders.svg" alt="">
            </div>
        </nz-card>
        
        <div class="leaders-header-arrow">
            <div class="arrow-down"></div>
        </div>

       
    </div> 

    <div nz-col nzSpan="24">

        
        <nz-list style="margin-top: 10px;" class="user-list"  style="max-height:69vh! important;overflow-y: scroll;">
            <nz-list-item class="user-item" *ngFor="let item of pointsList">
              <span nz-typography class="text-fix"><span nz-icon nzType="user" nzTheme="outline"></span>  {{item.name}}</span>  
              <nz-tag nzColor="success" style="margin:0px" *ngIf="item.sum > 90">{{item.sum}}</nz-tag> 
              <nz-tag nzColor="warning" style="margin:0px" *ngIf="item.sum > 24 && item.sum < 76">{{item.sum}}</nz-tag> 
              <nz-tag nzColor="error" style="margin:0px" *ngIf="item.sum < 25">{{item.sum}}</nz-tag> 
            </nz-list-item>
          </nz-list>


        <!-- <nz-card class="leaders-header-card">
            <div class="header-wrapper"> 
                <div style="margin-right: 20px;">
                    <h3 style="margin-bottom: 6px">Leaders</h3>
                    <h3 style="margin-bottom: 6px">Dashboard</h3>
                </div>
                <img src="../../../assets/images/leaders.svg" alt="">
            </div>
        </nz-card> -->
    </div> 
</div>